import { render, staticRenderFns } from "./StatisticsProfessorMarksView.vue?vue&type=template&id=6b35639e"
import script from "./StatisticsProfessorMarksView.vue?vue&type=script&lang=js"
export * from "./StatisticsProfessorMarksView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports